<template>
  <nuttrema-layout-default-slide
    :layout-slide-mode-key="KEYS.LAYOUT_STUFF_TO_EAT_VIEW_SLIDE_MODE">

    <template slot="overflow">

      <page-help
         v-if="show.pageHelp"
         file="program-diet"
        :title="$t('label.help')"
        :anchor="`#${$route.name}`"
        @close="show.pageHelp = false">
      </page-help>

      <page-make-copy
         v-if="show.pageMakeCopy"
        :id="id"
        :type="type"
        @close="show.pageMakeCopy = false">
      </page-make-copy>

    </template>

    <template slot="collapsed-menu-top-brand">
      <nuttrema-brand-image link="professional-home"></nuttrema-brand-image>
    </template>

    <template slot="collapsed-menu-top">
      <nuttrema-menu-list theme="sidebar-menu">

        <nuttrema-menu-list-item v-if="matched('dish-ingredients')">
          <permissions-control-wrapper
             action="label.add_new_ingredient"
            :required-general="$PERMISSIONS_GENERAL.EDIT"
            :permissions="_get(StuffToEatDetails, 'meta.permissions')">
            <router-link
               slot="allowed"
               tag="a" activeClass="is-active"
              :title="$t('label.add_new_ingredient')"
              :to="{ name: 'search-dish-ingredients', params: { type: STUFF_TO_EAT_KEYS.food_product },  }">
              <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
            </router-link>
            <nuttrema-iconica-sidebar-link slot="not-allowed" icon="far fa-plus" theme="add-button" disabled></nuttrema-iconica-sidebar-link>
          </permissions-control-wrapper>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item v-if="matched('dish-serving-sizes')">
          <permissions-control-wrapper
             action="label.add_new_serving_size"
            :required-general="$PERMISSIONS_GENERAL.ADD_SERVING"
            :permissions="_get(StuffToEatDetails, 'meta.permissions')">
            <router-link
               slot="allowed"
               tag="a" activeClass="is-active"
              :title="$t('label.add_new_serving_size')"
              :to="{ name: 'dish-serving-sizes-add' }">
              <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
            </router-link>
            <nuttrema-iconica-sidebar-link slot="not-allowed" icon="far fa-plus" theme="add-button" disabled></nuttrema-iconica-sidebar-link>
          </permissions-control-wrapper>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item v-if="matched('dish-exchanges')">
          <permissions-control-wrapper
             action="label.add_new_serving_size"
            :required-general="$PERMISSIONS_GENERAL.EDIT_EXCHANGES"
            :permissions="_get(StuffToEatDetails, 'meta.permissions')">
            <router-link
               slot="allowed"
               tag="a" activeClass="is-active"
              :title="$t('label.add_new_exchange')"
              :to="{ name: 'search-dish-exchanges', params: { entityType: STUFF_TO_EAT_KEYS.dish }, }">
              <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
            </router-link>
            <nuttrema-iconica-sidebar-link slot="not-allowed" icon="far fa-plus" theme="add-button" disabled></nuttrema-iconica-sidebar-link>
          </permissions-control-wrapper>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item v-if="matched('dish-images')">
          <permissions-control-wrapper
             action="label.upload_images"
            :required-general="$PERMISSIONS_GENERAL.EDIT"
            :permissions="_get(StuffToEatDetails, 'meta.permissions')">
            <router-link
               slot="allowed"
               tag="a" activeClass="is-active"
              :title="$t('label.upload_images')"
              :to="{ name: 'dish-images-upload' }">
              <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
            </router-link>
             <nuttrema-iconica-sidebar-link slot="not-allowed" icon="far fa-plus" theme="add-button" disabled></nuttrema-iconica-sidebar-link>
          </permissions-control-wrapper>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item v-if="matched('dish-instructions') && _get(StuffToEatDetails, 'data.sbs_instructions', false)">
          <permissions-control-wrapper
             action="label.use_step_by_step_instructions"
            :required-general="$PERMISSIONS_GENERAL.EDIT"
            :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.STEP_BY_STEP_INSTRUCTIONS"
            :permissions="_get(StuffToEatDetails, 'meta.permissions')">
            <router-link
               slot="allowed"
               tag="a" activeClass="is-active"
              :title="$t('label.add_new_step')"
              :to="{ name: 'dish-instructions-add-step' }">
              <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
            </router-link>
            <nuttrema-iconica-sidebar-link slot="not-allowed" icon="far fa-plus" theme="add-button" disabled></nuttrema-iconica-sidebar-link>
          </permissions-control-wrapper>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item class="collapsed-menu-level-one">
          <a><sidebar-icon-level-zero></sidebar-icon-level-zero></a>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item class="collapsed-menu-level-one">
          <router-link
             tag="a"
            :title="backTo.label"
            :to="backTo.route">
            <nuttrema-iconica-sidebar-link theme="gray" icon="far fa-arrow-left"></nuttrema-iconica-sidebar-link>
          </router-link>
        </nuttrema-menu-list-item>

      </nuttrema-menu-list>
    </template>

    <template slot="collapsed-menu-level-zero">
      <sidebar-menu-level-zero-collapsed
        class="collapsed-menu-level-zero is-collapsed">
      </sidebar-menu-level-zero-collapsed>
    </template>

    <template slot="collapsed-menu-level-one">
      <sidebar-menu-level-one-collapsed
         v-if="StuffToEatDetails.ready"
         class="collapsed-menu-level-one is-collapsed"
        :id="id"
        :details="StuffToEatDetails">
      </sidebar-menu-level-one-collapsed>
    </template>

    <template slot="expanded-menu-level-one">
      <nuttrema-loader v-if="StuffToEatDetails.fetching"></nuttrema-loader>
      <sidebar-menu-level-one-expanded
         v-else
         class="expanded-menu-level-one is-expanded"
        :id="id"
        :meta="meta"
        :details="StuffToEatDetails">
      </sidebar-menu-level-one-expanded>
    </template>

    <nuttrema-menu-list slot="sidebar-collapsed-bottom">
      <nuttrema-menu-list-item>
          <sidebar-link-overlay-usermenu></sidebar-link-overlay-usermenu>
      </nuttrema-menu-list-item>
    </nuttrema-menu-list>

  </nuttrema-layout-default-slide>
</template>

<script>
import { STUFF_TO_EAT_KEYS } from 'constants/types';

import SidebarMenuLevelZeroCollapsed from 'components/ui/menu/level-zero/sidebar-menu-level-zero-collapsed';

import SidebarMenuLevelOneCollapsed from 'components/ui/menu/stuff-to-eat/sidebar-menu-stuff-to-eat-dish-collapsed';
import SidebarMenuLevelOneExpanded from 'components/ui/menu/stuff-to-eat/sidebar-menu-stuff-to-eat-dish-expanded';

import LayoutSetAbstractStuffToEat from './layout-set-stuff-to-eat-abstract';

export default {
  name: 'layout-set-stuff-to-eat-dish',
  mixins: [LayoutSetAbstractStuffToEat],
  components: {
    SidebarMenuLevelOneExpanded,
    SidebarMenuLevelOneCollapsed,
    SidebarMenuLevelZeroCollapsed,
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
  },
  data() {
    return {
      type: STUFF_TO_EAT_KEYS.dish,
      STUFF_TO_EAT_KEYS,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/stuff-to-eat/layout-set-stuff-to-eat-dish.vue